import React from 'react';
import { Check, Lock, Download, Smartphone } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalOffer() {
  return <section className="py-10 md:py-14 px-5 bg-olive-700 text-cream-50 relative overflow-hidden" data-id="element-97">
      {/* Soft background accent */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(circle at 20% 20%, #FAF7F2 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-98"></div>

      <div className="relative max-w-3xl mx-auto" data-id="element-99">
        <div className="text-center mb-8 md:mb-10 max-w-2xl mx-auto" data-id="element-100">
          <p className="text-xs uppercase tracking-[0.2em] text-cream-300 font-medium mb-4" data-id="element-101">
            Llévatela hoy
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-5xl leading-tight mb-5" data-id="element-102">
            Tu biblioteca natural completa,{' '}
            <span className="italic text-cream-200" data-id="element-103">
              siempre a un clic de distancia
            </span>
          </h2>
          <p className="text-cream-200 text-base md:text-lg leading-relaxed" data-id="element-104">
            Más de 1,500 soluciones naturales en 5 ebooks premium, 10 bonos
            exclusivos de regalo y acceso inmediato para toda la vida.
          </p>
        </div>

        {/* Offer card */}
        <div className="bg-cream-50 text-ink-900 rounded-3xl p-7 md:p-10 shadow-2xl" data-id="element-105">
          <p className="text-center text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-5" data-id="element-106">
            Lo que incluye
          </p>

          <ul className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-107">
            {['5 ebooks premium con +1,500 soluciones naturales', 'Organizados por tema y por síntoma', '10 bonos exclusivos de regalo', 'Acceso inmediato y de por vida', 'Compatible con celular, tablet y PC'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-108">
                <div className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-olive-100 flex items-center justify-center" data-id="element-109">
                  <Check className="w-3 h-3 text-olive-700" strokeWidth={3} data-id="element-110" />
                </div>
                <span className="text-sm md:text-base text-ink-800 font-medium" data-id="element-111">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Price */}
          <div className="text-center mb-7 pb-7 border-b border-cream-300" data-id="element-112">
            <p className="text-sm text-ink-600 mb-1" data-id="element-113">
              Valor total <span className="line-through" data-id="element-114">$999 MXN</span>
            </p>
            <div className="flex items-baseline justify-center gap-2" data-id="element-115">
              <span className="text-xs font-medium text-olive-600 uppercase tracking-wider" data-id="element-116">
                Hoy
              </span>
              <span className="font-serif text-5xl md:text-6xl font-semibold text-ink-900" data-id="element-117">
                $299
              </span>
              <span className="text-sm text-ink-700 font-medium" data-id="element-118">MXN</span>
            </div>
            <p className="text-xs text-ink-600 mt-2" data-id="element-119">
              Pago único · Sin suscripciones
            </p>
          </div>

          <CTAButton subtext="Compra segura · Descarga inmediata" data-id="element-120" />

          {/* Trust row */}
          <div className="mt-7 flex items-center justify-center gap-5 md:gap-7 text-ink-600" data-id="element-121">
            <div className="flex items-center gap-1.5 text-xs" data-id="element-122">
              <Lock className="w-3.5 h-3.5" data-id="element-123" />
              <span data-id="element-124">Pago seguro</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-ink-500" data-id="element-125"></div>
            <div className="flex items-center gap-1.5 text-xs" data-id="element-126">
              <Download className="w-3.5 h-3.5" data-id="element-127" />
              <span data-id="element-128">Acceso inmediato</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-ink-500" data-id="element-129"></div>
            <div className="flex items-center gap-1.5 text-xs" data-id="element-130">
              <Smartphone className="w-3.5 h-3.5" data-id="element-131" />
              <span data-id="element-132">Celular y PC</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}